import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15b89ea6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "error-message"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 1 }

import { abbreviateAddress, pluralize } from '@/lib/claimUtil';
import { NETWORK_CONFIGS } from '@/lib/networks';
import { useClaimStore } from '@/store/claimStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'MintingQuantityError',
  setup(__props) {

const store = useClaimStore();

return (_ctx: any,_cache: any) => {
  return (
      !_unref(store).canMint &&
      (!_unref(store).hasAllowlist ||
        (_unref(store).hasAllowlist && !_unref(store).isResetingMerkleData && _unref(store).mintForWallet))
    )
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_unref(store).hasTokensToPurchase)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              (_unref(store).hasntMintedAnyTokens)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" Your address "),
                    _createElementVNode("a", {
                      href: `${
            _unref(NETWORK_CONFIGS)[_unref(store).networkId]?.blockExplorerUrls?.[0] || 'https://etherscan.io'
          }/address/${_unref(store).walletAddress}`,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      class: "error-message"
                    }, _toDisplayString(_unref(abbreviateAddress)(_unref(store).walletAddress || '')), 9, _hoisted_3),
                    _createTextVNode(" isn't on the access list for this drop. Try another address or contact the creator to confirm. ")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" You've claimed all your items. ")
                  ], 64))
            ]))
          : (_unref(store).isTryingToMintMoreTokensThanPossible)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "You can't claim more than " + _toDisplayString(`${_unref(store).maxNumberToPurchase} ${_unref(pluralize)(_unref(store).maxNumberToPurchase, 'item')}`), 1))
            : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})